module.exports = __webpack_public_path__ + "img/5.8e2aa534.jpg";